<template>
  <basic-container>
    <el-dialog
      title="打印预览"
      :visible.sync="payChargePrintPreShowDialogFlag"
      :modal-append-to-body="false"
      width="64%"
      @closed="handleClose"
    >
      <div class="el-property-dialog-div">
        <avue-form
          v-if="payChargePrintPreShowDialogFlag"
          v-model="payChargePrintPreForm"
          :option="payChargePrintPreOption"
          ref="payChargePrintPreFormRef"
          @submit="printSave"
          @click="saveF5"
        >
          <template slot-scope="scope" slot="menuForm">
            <!--<el-button type="primary" @click="printSave">保存</el-button>-->
            <el-button type="danger" @click="print('rule')">打印</el-button>
            <el-button type="danger" @click="print('fast')">一键打印</el-button>
            <!--<el-button type="danger" @click="printElecBill">电子票据打印</el-button>-->
          </template>
        </avue-form>
      </div>
      <el-dialog
        title="电子票据"
        :visible.sync="pdfDialogFlag"
        width="50%"
        @closed="handlePdfClose"
        append-to-body
      >
        <iframe width="100%" height="700" :src="printPdfUrl"></iframe>
      </el-dialog>
    </el-dialog>
  </basic-container>
</template>

<script>
import { billPrintPerv, billPrintSave, checkPayBillNo, billPrint } from '@/api/charge/index';
import payChargePrintPreOption from './printdialog-option';
import urlSettings from '@/config/url-settings.js';
export default {
  data() {
    return {
      printPdfUrl: '',
      pdfDialogFlag: false,
      payChargePrintPreShowDialogFlag: false,
      payChargePrintPreForm: {},
      payChargePrintPreOption: payChargePrintPreOption,
      invoiceNo: '',
      printTimes: '',
      payBillNo: '',
      printFlag:true,
    };
  },
  computed: {},
  methods: {
    openPayChargePrintPreDialog(payBillNo) {
      this.payBillNo = payBillNo;
      billPrintPerv({ payBillNo: payBillNo }).then(({ data }) => {
        this.payChargePrintPreForm = data;
        this.invoiceNo = data.invoiceNo;
        // var text = this.findObject(this.payChargePrintPreOption.column, 'invoiceNo');
        // if (this.invoiceNo) {
        //   text.disabled = true;
        // } else {
        //   text.disabled = false;
        // }
        this.printTimes = data.printTimes;
      });
      this.payChargePrintPreShowDialogFlag = true;
    },
    saveF5() {
      this.$emit('saveF5');
    },
    //打印保存
    printSave(form, done) {
      this.$refs.payChargePrintPreFormRef.validate((valid) => {
        if (valid) {
          billPrintSave(form).then(
            () => {
              this.$message.success('操作成功!');
              // var text = this.findObject(this.payChargePrintPreOption.column, 'invoiceNo');
              // text.disabled = true;
              done();

              this.$emit('saveF5');
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    resetPrintForm(){
        this.payChargePrintPreShowDialogFlag = false;
        setTimeout(()=>{
          this.payChargePrintPreShowDialogFlag = true;
        });
    },
    //打印
    print(type) {

      //打印开关 避免重复提交
      if(!this.printFlag){
        return;
      }
      this.printFlag = false;
      this.$refs.payChargePrintPreFormRef.validate((valid) => {
        if (valid) {
          checkPayBillNo(this.payChargePrintPreForm).then(
            () => {
              //打印更新数据
              billPrint(this.payChargePrintPreForm).then(
                () => {
                  //票据号未被使用过，打开cpt页面
                  if(type=='fast'){
                    this.openPrintWindow('fast');
                  }else{
                    this.openPrintWindow('rule');
                  }

                  this.printTimes++;
                  this.resetPrintForm();
                },
                (error) => {
                  console.log(error);
                  this.resetPrintForm();
                }
              );
            },
            (error) => {
              this.printFlag = true;
              this.resetPrintForm();
              done();
              console.log(error);
            }
          );
        }else{
          this.printFlag = true;
        }
      });
    },
    //电子票据打印
    printElecBill() {
      this.$refs.payChargePrintPreFormRef.validate((valid) => {
        if (valid) {
          checkPayBillNo(this.payChargePrintPreForm).then(
            () => {
              //打印更新数据
              billPrint(this.payChargePrintPreForm).then(
                ({ data }) => {
                  this.pdfDialogFlag = true;
                  this.printPdfUrl = location.origin + '/pdfjs/web/viewer.html?file=' + data;
                  debugger;
                },
                (error) => {
                  console.log(error);
                }
              );
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    //打开cpt页面
    openPrintWindow(type) {
      //打印次数
      let printTimes = this.printTimes + 1;
      //票据号
      let payBillNo = this.payBillNo;

      //跳转帆软html处理页面地址 并把票据号传到页面上
      let path = '';
      if(type=='fast'){
         if (printTimes > '0') {
        this.$message({
            message: '已打印[' + printTimes + ']次',
            type: 'warning'
        });
        setTimeout(()=>{
          this.printFlag = true;
        },1000)
      } else {
        this.printFlag = true;
      }
        // path = urlSettings.VUE_APP_BASE_REPORT_URL.split('ReportServer?')[0]  +'html/printbill.html?payBillNo='  + payBillNo + '&reportUrl='+ urlSettings.VUE_APP_REPORT_ENVIRONMENT;
        path = 'http://localhost:8075/WebReport/ReportServer?reportlet=newbill2.cpt&op=write'
        path = urlSettings.VUE_APP_BASE_REPORT_URL + urlSettings.VUE_APP_ENVIRONMENT + '/fastNewbill.cpt&op=write&payBillNo='+payBillNo;
        window.open(
          path,
          'newindow',
          'height=600,width=1100,top=100,left=100,toolbar=no,' +
            'menubar=no,scrollbars=no,resizable=no,location=no,status=no,z-look=yes'
        );

      }else{
        path = urlSettings.VUE_APP_BASE_REPORT_URL.split('ReportServer?')[0]  +'html/printbill.html?payBillNo='  + payBillNo + '&reportUrl='+ urlSettings.VUE_APP_REPORT_ENVIRONMENT;
         if (printTimes > '0') {
          this.$message({
              message: '已打印[' + printTimes + ']次',
              type: 'warning'
          });
          setTimeout(()=>{
            this.printFlag = true;
            window.open(path);
          },1000)
        } else {
          this.printFlag = true;
          window.open(path);
        }
      }

      //票据号
      // let path = urlSettings.BASE_REPORT_URL + cptName + '&op=write&payBillNo=' + payBillNo;

      // 不再让用户点击确定 直接展示已打印多少次


    },
    handleClose() {
      this.$refs.payChargePrintPreFormRef.resetForm();
    },
    handlePdfClose() {
      this.$refs.payChargePrintPreFormRef.resetForm();
      this.payChargePrintPreShowDialogFlag = false;
      this.printPdfUrl = '';
    },
  },
};
</script>

